<template>
  <div>
    <el-dialog
      title="解绑手机号"
      :visible.sync="disabled"
      width="400px"
      @close="close"
      :modal="false"
    >
      <span style="text-align: center"
        >{{ form.UserInfo.name }}确定与{{ form.mobile }}解绑吗？</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close" :loading="btnLoading">
          取 消
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="Recharge"
          :loading="btnLoading"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getData } from "@/api/index";
export default {
  props: {
    isShow: Boolean,
    rowData: Object,
  },
  data() {
    return {
      form: {},
      disabled: this.isShow,
      btnLoading: false,
      loading: false,
    };
  },
  async created() {
    this.form = { ...this.rowData, status: 0 };
  },
  methods: {
    async Recharge() {
      this.btnLoading = true;
      let params = {
        id: this.form.id,
        status: 0,
        user_id: this.form.user_id,
        mobile: this.form.mobile,
      };
      let res = await getData(
        "company.CompanyUserController/bindStatusAction",
        params
      );
      this.btnLoading = false;
      if (res.code !== 200) return this.$message.error(res.message);
      this.$message.success("解绑成功");
      this.close();
      this.$parent.esarchang();
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" src="@/assets/css/tablecss.less" scoped></style>
